import { Result } from "@swan-io/boxed";

const uploadFile = async (url: string, file: File): Promise<Result<string, number>> => {
  const data = new FormData();
  data.append("file", file);

  const response = await fetch(url, {
    method: "POST",
    body: data,
  });

  if (response.ok) {
    return Result.Ok(await response.text());
  } else {
    return Result.Error(response.status);
  }
};

export const uploadUserAvatar = (logoFile: File): Promise<Result<string, number>> => {
  return uploadFile("/api/upload/avatar", logoFile);
};

export const uploadOrgLogo = (org_id: number, logoFile: File): Promise<Result<string, number>> => {
  return uploadFile(`/api/upload/logo/${org_id}`, logoFile);
};

export const uploadTeamIcon = (
  org_id: number,
  team_id: number,
  logoFile: File,
): Promise<Result<string, number>> => {
  return uploadFile(`/upload/icon/${org_id}/${team_id}`, logoFile);
};
